import { render, staticRenderFns } from "./CompletionButton.vue?vue&type=template&id=5d5e7cd5&scoped=true&"
import script from "./CompletionButton.vue?vue&type=script&lang=ts&"
export * from "./CompletionButton.vue?vue&type=script&lang=ts&"
import style0 from "./CompletionButton.vue?vue&type=style&index=0&id=5d5e7cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e7cd5",
  null
  
)

export default component.exports